import type { JSX } from 'react'

export const QualityBadge2kIcon = (): JSX.Element => (
  <use href='#qualityBadge2kIcon' height='100%' width='100%' />
)
